import { create } from 'zustand';

export const useChatViewStore = create((set, get) => ({
  chatContainerElement: null,
  isInitialMount: true,

  setChatContainerElement: (element) => set({
    chatContainerElement: element,
  }),
  setIsInitialMount: (valueOrFn) => set((state) => ({
    isInitialMount: typeof valueOrFn === 'function'
      ? valueOrFn(state.isInitialMount)
      : valueOrFn,
  })),
  scrollChatToBottom: () => {
    const container = get().chatContainerElement;

    if (container) {
      container.scrollTo({
        top: container.scrollHeight,
      });
    }
  },
}));
